import { SmallButton } from "@sellar-io/components";
import { ReactElement, useEffect, useState } from "react";
import { Icon } from "../../components";
import { NavigationBarMenu } from "../../components/navigation/NavigationBar";
import { useEvents } from "../../hooks";
import { NewConnectionCommentThreadModal } from "./Dialogs/NewConnectionCommentThreadModal";
import { MessageTypeList } from "./MessageTypeList";
import { useMessageTabSelect } from "./useMessageTabSelect";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { useShowTermsAndConditionsModal } from "../../hooks/useShowTermsAndConditionsModal";
import { TermsAndConditionsDialog } from "../settings/termsAndConditions/TermsAndConditionsDialog";

export function MessageList(): ReactElement {
  const { business } = useSellarCurrentBusiness();
  const { track } = useEvents();
  useEffect(() => {
    track("Messaging Page Viewed");
  }, [track]);

  const [active, setActive] = useState(false);
  const [showNewMessage, setShowNewMessage] = useState(true);
  const [selectedTab] = useMessageTabSelect();
  const [previousSelectedTab, setPreviousSelectedTab] = useState(selectedTab);
  if (selectedTab !== previousSelectedTab) {
    setPreviousSelectedTab(selectedTab);
    setShowNewMessage(selectedTab === "Direct messages");
  }

  const [termsActive, setTermsActive] = useState(false);

  const termsAndConditionsEnabled = useShowTermsAndConditionsModal();

  const handleNewMessageClick = () => {
    if (termsAndConditionsEnabled && !!business?.Supplier) {
      setTermsActive(true);
    } else {
      setActive(true);
    }
  };

  const handleTermsDismiss = (accepted: boolean) => {
    setTermsActive(false);
    if (accepted) setActive(true);
  };

  return (
    <>
      <NavigationBarMenu
        title={"Messages"}
        borderBottom={false}
        rightComponent={
          showNewMessage && (
            <SmallButton onClick={handleNewMessageClick}>
              <Icon icon={"PENCIL"} size={0.7} />
              New
            </SmallButton>
          )
        }
      />
      <MessageTypeList />
      <NewConnectionCommentThreadModal active={active} setActive={setActive} />
      <TermsAndConditionsDialog
        active={termsActive}
        onDismiss={handleTermsDismiss}
      />
    </>
  );
}
